export const LinkedInIcon = ({ primaryFontColor = '#ffd800' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="sourcing" transform="translate(24 -0.001) rotate(90)">
        <path
          id="Path_63843"
          data-name="Path 63843"
          d="M35.79,52.95a10.553,10.553,0,0,1,1.572.476,4.593,4.593,0,0,0-.8.52A6.8,6.8,0,0,0,35.79,52.95Z"
          transform="translate(-22.168 -50.866)"
          fill={primaryFontColor}
        />
        <path
          id="Path_63844"
          data-name="Path 63844"
          d="M24.991,11.37q-.3.013-.6.013t-.6-.013A3.235,3.235,0,0,1,22.345,10.3,13.506,13.506,0,0,1,19.97,4h8.837a13.487,13.487,0,0,1-2.375,6.309A3.255,3.255,0,0,1,24.991,11.37Z"
          transform="translate(-13.205 12.617)"
          fill={primaryFontColor}
        />
        <path
          id="Path_63845"
          data-name="Path 63845"
          d="M35.79,11.743a6.934,6.934,0,0,0,.869-1.148A16.122,16.122,0,0,0,38.61,4.64h5.309A11.359,11.359,0,0,1,35.79,11.743Z"
          transform="translate(-22.29 11.977)"
          fill={primaryFontColor}
        />
        <path
          id="Path_63846"
          data-name="Path 63846"
          d="M46.654,24.2a4.227,4.227,0,0,0,.327-.362,4.736,4.736,0,0,0,.589-.926,11.25,11.25,0,0,1,.847,4.3,11.106,11.106,0,0,1-.428,3.065H42.52a26.641,26.641,0,0,0,.17-3.065q0-.858-.052-1.677A4.72,4.72,0,0,0,46.654,24.2Z"
          transform="translate(-26.082 -14.309)"
          fill={primaryFontColor}
        />
        <path
          id="Path_63847"
          data-name="Path 63847"
          d="M19.97,46.343a13.506,13.506,0,0,1,2.375-6.3,3.234,3.234,0,0,1,1.441-1.065q.3-.013.6-.013t.6.013a3.255,3.255,0,0,1,1.441,1.061,6.464,6.464,0,0,1,.576.821,4.746,4.746,0,0,0-.476,5.488Z"
          transform="translate(-13.191 -37.156)"
          fill={primaryFontColor}
        />
        <path
          id="Path_63848"
          data-name="Path 63848"
          d="M5.79,46.063a11.346,11.346,0,0,1,8.121-7.1,7.213,7.213,0,0,0-.864,1.153,16.015,16.015,0,0,0-1.956,5.951Z"
          transform="translate(-5.077 -36.876)"
          fill={primaryFontColor}
        />
        <path
          id="Path_63849"
          data-name="Path 63849"
          d="M4.16,25.979a11.137,11.137,0,0,1,.428-3.069h5.466a27.712,27.712,0,0,0,0,6.134H4.588a11.106,11.106,0,0,1-.428-3.065Z"
          transform="translate(-4.159 -13.097)"
          fill={primaryFontColor}
        />
        <path
          id="Path_63850"
          data-name="Path 63850"
          d="M11.085,4.64A16.04,16.04,0,0,0,13.04,10.6a7.169,7.169,0,0,0,.864,1.148A11.345,11.345,0,0,1,5.78,4.64Z"
          transform="translate(-5.072 11.977)"
          fill={primaryFontColor}
        />
        <path
          id="Path_63851"
          data-name="Path 63851"
          d="M19.27,25.978a25.813,25.813,0,0,1,.183-3.067l7.352,0a.725.725,0,0,0,.057.061,4.752,4.752,0,0,0,1.786,1.118c.048.616.07,1.249.07,1.89a25.7,25.7,0,0,1-.183,3.066H19.453a25.7,25.7,0,0,1-.183-3.065Z"
          transform="translate(-12.81 -13.095)"
          fill={primaryFontColor}
        />
        <path
          id="Path_63852"
          data-name="Path 63852"
          d="M45.677,38.253l-1.585,1.585a.435.435,0,0,1-.616,0l-.462-.462-.645.645a3.858,3.858,0,1,1-.617-.617l.645-.645-.462-.462a.435.435,0,0,1,0-.616L43.52,36.1a1.525,1.525,0,1,1,2.157,2.157Zm-4.215,2.058a2.987,2.987,0,1,0,0,4.224A2.987,2.987,0,0,0,41.462,40.312Z"
          transform="translate(-22.122 -35.65)"
          fill={primaryFontColor}
        />
      </g>
    </svg>
  );
};
